import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import OperatingProceduresCustomerForm from "../../../../components/MainForm/OperatingProceduresCustomerForm";
import DataRecordingCommandForm from "../../../../components/MainForm/DataRecordingCommandForm";
import StatusSparepartCommandForm from "../../../../components/MainForm/StatusSparepartCommandForm";
import ItemStdCustomersService from "../../../../services/itemstdcustomer.service";
import ItemStdRecordsService from "../../../../services/itemstdrecord.service";

export default function EditServiceRequest() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [editData, setEditData] = useState(null);
  const titleId =
    state.type === "StdCus"
      ? "แก้ไขขั้นตอนการปฏิบัติงานเฉพาะลูกค้า"
      : state.type === "Check"
      ? "แก้ไขสถานะ คำสั่งตรวจสอบ/เปลี่ยน Sparepart"
      : "แก้ไขคำสั่งการบันทึกข้อมูล";
  const descriptionText =
    state.type === "StdCus"
      ? "Additional Customer Specific Steps"
      : state.type === "Check"
      ? "Status Inspect/Change Sparepart Command"
      : "Data Recording Command";

  const getItemStdCustomerById = () => {
    setLoading(true);
    ItemStdCustomersService.getItemStdCustomers(id)
      .then((response) => setEditData(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const getItemStdRecordById = () => {
    setLoading(true);
    ItemStdRecordsService.getItemStdRecords(id)
      .then((response) => setEditData(response))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmitOperatingCustomer = (dataCallback) => {
    setLoading(true);
    ItemStdCustomersService.editItemStdCustomers(id, dataCallback)
      .then((_) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        navigate(0);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmitStatus = (dataCallback) => {
    console.log(dataCallback);
    navigate(0);
  };

  const handleSubmitRecording = (dataCallback) => {
    setLoading(true);
    ItemStdRecordsService.editItemStdRecords(id, dataCallback)
      .then((_) => {
        showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
        navigate(0);
      })
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (state.type === "StdCus") getItemStdCustomerById();
    else getItemStdRecordById();
  }, []);

  return (
    <>
      <Helmet>
        <title>{titleId}</title>
        <meta name="description" content={`Edit ${descriptionText} Page`} />
      </Helmet>

      <Container fluid className="p-3">
        {state.type === "StdCus" ? (
          <OperatingProceduresCustomerForm
            editData={editData}
            searchValue={state?.searchValue}
            onSubmitCallback={handleSubmitOperatingCustomer}
          />
        ) : state.type === "Check" ? (
          <StatusSparepartCommandForm
            editData={editData}
            onSubmitCallback={handleSubmitStatus}
          />
        ) : (
          <DataRecordingCommandForm
            editData={editData}
            searchValue={state?.searchValue}
            onSubmitCallback={handleSubmitRecording}
          />
        )}
      </Container>
    </>
  );
}
